export default __webpack_public_path__ + "static/media/menu-closed.a8b5ca82.svg";